<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click.stop="exportarPlanilha(itemContratoId)">
            <span
                class="icon-button"
                title="Requisições ao item"
            >
            <i class="fa fa-download"></i>
            </span>
        </b-button>
    </div>
</template>

<script>
import ContratosServicos from '../ContratosServicos'

export default {
    props: {
        contrato: {
            type: Object,
            default: () => ({})
        },
        itemContratoId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
        }
    },

    methods: {
        exportarPlanilha(contrato) {
            this.$store.dispatch('addRequest')
            ContratosServicos.exportarPlanilhaRequisicoesPorItem(contrato).then(
                (response) => {
                    if (response) {
                        if (response.type === 'application/json') {
                        this.$toast.error(
                            'Erro ao emitir relatório',
                            'ERROR',
                            this.$toastConfig.error
                        )
                        } else {
                            this.$download(response, 'Requisicoes.xlsx')
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },
    }
}
</script>
